export default "__VITE_ASSET__8728da77__"